import { ctaImage } from "@/mocks/techData";

export default function FinalCTA() {
  return (
    <section className="relative flex min-h-[80vh] items-center overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src={ctaImage}
          alt="Premium smartphone, laptop and accessories at Fist Limited in Liverpool"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/45 to-foreground-950/85"></div>

      <div className="container-x relative z-10 w-full py-24 text-center md:py-32">
        <p className="eyebrow-light mb-5 justify-center">Fist Limited · Liverpool</p>
        <h2 className="mx-auto max-w-4xl font-heading text-4xl leading-[1.02] tracking-tight text-background-50 sm:text-5xl md:text-6xl">
          Find your next
          <br />
          <span className="text-primary-400">tech essential.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-background-100/75">
          Mobiles, laptops and everyday accessories from Fist Limited.
        </p>

        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a href="#products" className="btn-primary h-12 px-7 text-sm">
            Explore Products <i className="ri-arrow-right-line"></i>
          </a>
          <a href="#visit" className="btn-light-outline h-12 px-7 text-sm">
            Visit Fist Limited
          </a>
        </div>

        <p className="mt-8 font-label text-xs text-background-100/60">
          86 Eastdale Road · Liverpool · L15 4HW
        </p>
      </div>
    </section>
  );
}